export default __webpack_public_path__ + "static/media/IPmobile.42a9255b.png";